<template>
  <div id="page-news">
    <ContentHeader>
      <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
      <h1 class="header__title">{{ $wp.header.title }}</h1>
      <p class="header__text">{{ $wp.header.content }}</p>
    </ContentHeader>

    <ContentSection>
      <menu class="filter-bar">
        <PageLink
          v-for="{ icon, link, label } in filters"
          :key="label"
          :to="link"
          class="filter-bar__link row -align-center"
          exact
        >
          <Icon v-if="icon" :id="icon" class="filter-bar__icon" />
          {{ label }}
        </PageLink>
      </menu>

      <TransitionGroup name="news-item" tag="div" class="news-item__list row -start -wrap">
        <article v-for="(article, slug) in articles" :key="slug" class="card -article news-item">
          <figure v-if="article.image" class="card__image" :style="{ backgroundImage: `url(${article.image})` }" />

          <div class="card__content">
            <div>
              <h5 class="card__title">{{ article.title }}</h5>
              <time class="card__caption">{{ article.published }}</time>
              <p>{{ article.excerpt }}</p>
            </div>

            <RouterLink :to="getArticleLink(article)" class="card__link">{{ viewLabel }}</RouterLink>
          </div>
        </article>
      </TransitionGroup>
    </ContentSection>
  </div>
</template>

<script>
import { ContentSection, ContentHeader } from '@/components/content'

export default {
  name: 'News',
  contentKey: 'news',
  components: { ContentSection, ContentHeader },
  props: {
    category: { type: String, default: null }
  },
  computed: {
    headerStyle() {
      const { image } = this.$wp.header
      return image ? { backgroundImage: `url(${image})` } : {}
    },
    articles() {
      const articles = Object.values(this.$store.state.collections.articles)
      if (!this.category) return articles

      const categoryId = this.$store.getters.newsFilterSlugMap[this.category]
      return articles.filter(({ categories }) => {
        if (!categories) return false
        return categories.includes(categoryId)
      })
    },
    allCategoriesLabel() {
      return this.$lang.current === 'en' ? 'All news' : 'Toutes les nouvelles'
    },
    filters() {
      const { current } = this.$lang
      const newsCategories = Object.values(this.$store.getters.currentNewsCategories)

      return [
        { label: this.allCategoriesLabel, link: this.$lang.route({ name: 'news' }) },
        ...newsCategories.map(({ slug, title, icon }) => ({
          icon,
          label: title[current],
          link: { name: 'news', params: { category: slug[current] } }
        }))
      ]
    },
    viewLabel() {
      return this.$lang.current === 'en' ? 'Read this news' : 'Lire cette nouvelle'
    }
  },
  methods: {
    getArticleLink({ slug, categories }) {
      const [categoryId] = categories || []
      const category = categoryId
        ? this.$store.getters.currentNewsCategories[categoryId].slug[this.$lang.current]
        : 'all'

      return this.$lang.route({ name: 'article', params: { category, articleSlug: slug } })
    }
  }
}
</script>
